









































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch, Mixins } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storePerawat } from "@/store/modules/perawat";
import LaporanOperasi from "@/services/LaporanOperasi";
import { appModule } from "@/store/modules/app";
import { confirmRemove } from "@/utility/CommonHelper";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DateFormat from "@/utility/DateFormat";
import LaporanOperasiStore from "@/store/modules/LaporanOperasi";
import {
  LaporanOperasi as LapOpType,
  PetugasRingkas
} from "@/types/laporan_operasi";

@Component({
  components: {
    CardModalTtd
  }
})
export default class LaporanOperasiInput extends Mixins(PrefillMixin) {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ default: null }) readonly data!: Partial<LapOpType> | null;
  @Prop({ type: Boolean, default: false }) readonly viewOnly!: boolean;

  // 0 = Umum (default), 1 = Maternal Perinatal
  kategoriTab = 0;

  // ── Soft-prefill (FormPrefill engine) ──────────────────────────────
  prefillFormKey = "laporan_operasi";

  prefillResolvePath(path: string) {
    const slotFor = (field: string) => ({
      get: () => (this as any)[field],
      set: (v) => {
        (this as any)[field] = v;
      }
    });
    switch (path) {
      case "dx_pra_ops":
        return slotFor("dxPraOps");
      case "jenis_anestesi":
        return slotFor("jenisAnestesi");
      case "perdarahan_ml":
        return slotFor("perdarahanMl");
      case "transfusi_ml":
        return slotFor("transfusiMl");
      case "transfusi_komponen":
        return slotFor("transfusiKomponen");
      default:
        return { get: () => "__skip__", set: () => undefined };
    }
  }
  // ───────────────────────────────────────────────────────────────────

  @Ref() readonly dateTimePicker;
  @Ref() readonly refJenisImplant: HTMLInputElement;
  @Ref() opStartedAtPicker: HTMLElement;
  @Ref() opEndedAtPicker: HTMLElement;
  @Ref() refTglOperasi: HTMLElement;
  @Ref() refTglSelesaiOperasi: HTMLElement;
  @Ref() refOpTimeStartedAt: HTMLElement;
  @Ref() refOpTimeEndedAt: HTMLElement;
  @Ref() refDxPraOps: HTMLElement;

  saving = false;
  removing = false;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };
  todayDate = moment().format("YYYY-MM-DD");
  dateTimeFieldProps = { outlined: true, dense: true, "hide-details": "auto" };
  get dropDownProps() {
    return this.viewOnly
      ? { disabled: true }
      : { openOnHover: true, offsetY: true };
  }

  id = null;
  drOp1 = null;
  drOp2 = null;
  asisten = [];
  implant = null;
  jenisImplant = null;
  jaringanEksisi = null;
  komplikasi = null;
  komplikasiText = null;
  pemeriksaanPa = null;
  dxPraOps = null;
  dxPascaOps = null;
  namaTindakan = "t6";
  namaTindakanText = null;
  jenisTindakan = null;
  klasifikasiTindakan = null;
  lapOps = null;
  instruksiOp1 = null;
  lapOpsLanjutanOp1 = null;
  lapOpsOp2 = null;
  instruksiOp2 = null;
  lapOpsStruct: Record<string, string | null> = {
    posisi_pasien: null,
    persiapan_antisepsis: null,
    insisi: null,
    temuan_intraop: null,
    prosedur: null,
    spesimen: null,
    penutupan: null,
    komplikasi_intraop: null
  };
  instruksiStruct: Record<string, string | null> = {
    mobilisasi: null,
    diet: null,
    medikamentosa: null,
    monitoring: null,
    penunjang: null,
    perawatan_luka: null,
    rencana_kontrol: null,
    catatan_khusus: null
  };
  lapOpsModeBebas = false;
  instruksiModeBebas = false;
  hydrating = false;

  get lapOpsSections() {
    return [
      {
        key: "posisi_pasien",
        label: "Posisi Pasien",
        placeholder: "Supine / Litotomi / Prone / Lateral kiri / ..."
      },
      {
        key: "persiapan_antisepsis",
        label: "Persiapan & Antisepsis",
        placeholder:
          "Desinfeksi povidone iodine 10%, drape steril area operasi"
      },
      {
        key: "insisi",
        label: "Insisi",
        placeholder:
          "Jenis (Pfannenstiel / Mc Burney / Median / ...), lokasi, panjang"
      },
      {
        key: "temuan_intraop",
        label: "Temuan Intra-operatif",
        placeholder: "Temuan organ, patologi, kondisi anatomi"
      },
      {
        key: "prosedur",
        label: "Prosedur",
        placeholder: "Langkah-langkah tindakan secara berurutan"
      },
      {
        key: "spesimen",
        label: "Jaringan / Spesimen",
        placeholder: "Jaringan yang diangkat / dikirim PA"
      },
      {
        key: "penutupan",
        label: "Penutupan",
        placeholder:
          "Lapis demi lapis: peritoneum / fascia / subkutan / kulit; jenis benang & teknik"
      },
      {
        key: "komplikasi_intraop",
        label: "Komplikasi Intra-operatif",
        placeholder: "Tidak ada / sebutkan bila ada"
      }
    ];
  }

  get instruksiSections() {
    return [
      {
        key: "mobilisasi",
        label: "Posisi & Mobilisasi",
        placeholder: "Bed rest 24 jam, miring kiri-kanan, mobilisasi bertahap"
      },
      {
        key: "diet",
        label: "Diet",
        placeholder: "Puasa s/d bising usus +, diet bertahap (cair → lunak)"
      },
      {
        key: "medikamentosa",
        label: "Medikamentosa",
        placeholder:
          "Antibiotik / analgetik / uterotonika / cairan IV (dosis & rute)"
      },
      {
        key: "monitoring",
        label: "Monitoring",
        placeholder: "TTV per ... jam, balans cairan, drain, urin"
      },
      {
        key: "penunjang",
        label: "Pemeriksaan Penunjang",
        placeholder: "DR ulang H+1, USG / RO sesuai indikasi"
      },
      {
        key: "perawatan_luka",
        label: "Perawatan Luka / Drain",
        placeholder: "GV H+2, AFF drain bila produksi < 50 cc/24 jam"
      },
      {
        key: "rencana_kontrol",
        label: "Rencana Kontrol / Pulang",
        placeholder: "Rencana pulang H+3, kontrol poli ... 7 hari"
      },
      {
        key: "catatan_khusus",
        label: "Catatan Khusus",
        placeholder: "Lapor DPJP bila ..."
      }
    ];
  }

  get lapOpsStructHasValue() {
    return Object.values(this.lapOpsStruct || {}).some(
      v => typeof v === "string" && v.trim() !== ""
    );
  }

  get instruksiStructHasValue() {
    return Object.values(this.instruksiStruct || {}).some(
      v => typeof v === "string" && v.trim() !== ""
    );
  }
  pengobatan = null;
  perdarahanMl: number | null = null;
  transfusiMl: number | null = null;
  transfusiKomponen: string | null = null;
  showPelaksanaInput = false;
  inpPelaksanaNama = null;
  inpPelaksanaRole = null;
  showJamMulai = false;
  showJamSelesai = false;
  jenisAnestesi = null;
  drOp1SignedAt = null;
  drOp2SignedAt = null;
  drOp1Identity = null;
  drOp2Identity = null;
  forceEdit = false;
  // opStartedAt: any = null;
  // opEndedAt: any = null;
  tglOperasi = moment().format("YYYY-MM-DD");
  tglSelesaiOperasi = null;
  opTimeStartedAt: string = null;
  opTimeEndedAt: string = null;
  drAnestesi = null;
  perawat = [];
  asistenAnestesi = [];
  showData = false;

  mounted() {
    // this.getByRegister();
  }

  get opStartedAt() {
    if (
      this.tglOperasi &&
      this.opTimeStartedAt &&
      this.opTimeStartedAt.length >= 5
    ) {
      return moment(`${this.tglOperasi} ${this.opTimeStartedAt}:00`).toDate();
    } else {
      return null;
    }
  }

  get opEndedAt() {
    if (
      this.tglSelesaiOperasi &&
      this.opTimeEndedAt &&
      this.opTimeEndedAt.length >= 5
    ) {
      return moment(
        `${this.tglSelesaiOperasi} ${this.opTimeEndedAt}:00`
      ).toDate();
    } else {
      return null;
    }
  }

  get stateUser() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.list;
  }

  get listKaryawan() {
    return storePerawat.listKaryawan;
  }

  get dokterItems() {
    return this.withSavedPetugas(this.listDokter, [
      this.data?.dokter_operator1,
      this.data?.dokter_operator2,
      this.data?.dokter_anestesi
    ]);
  }

  get karyawanItems() {
    return this.withSavedPetugas(this.listKaryawan, [
      ...(this.data?.asisten || []),
      ...(this.data?.perawat || []),
      ...(this.data?.asisten_anestesi || [])
    ]);
  }

  withSavedPetugas<T extends { id: unknown }>(
    list: T[],
    saved: Array<PetugasRingkas | null | undefined>
  ): Array<T | PetugasRingkas> {
    const base: Array<T | PetugasRingkas> = list || [];
    const known = new Set(base.map(o => String(o.id)));
    const extra: PetugasRingkas[] = [];
    for (const p of saved) {
      if (!p || p.id == null || known.has(String(p.id))) continue;
      known.add(String(p.id));
      extra.push(p);
    }
    return extra.length ? [...base, ...extra] : base;
  }

  get jenisTindakanOptions() {
    return [
      { id: "emergensi", name: "Emergensi" },
      { id: "elektif", name: "Elektif" },
      { id: "odc", name: "ODC" }
    ];
  }

  get klasifikasiOptions() {
    return [
      { id: "khusus", name: "Khusus" },
      { id: "mayor", name: "Mayor" },
      { id: "medium", name: "Medium" },
      { id: "minor", name: "Minor" }
    ];
  }

  get kategori(): "umum" | "maternal" {
    return this.kategoriTab === 1 ? "maternal" : "umum";
  }

  get isMaternalKategori() {
    return this.kategori === "maternal";
  }

  get kategoriLabel() {
    return this.isMaternalKategori ? "Maternal Perinatal" : "Umum";
  }

  get defaultCategory(): string | null {
    return this.isMaternalKategori ? null : "t6";
  }

  get defaultModeBebas(): boolean {
    return !this.isMaternalKategori;
  }

  objectHasValue(obj: any): boolean {
    return (
      !!obj &&
      typeof obj === "object" &&
      Object.values(obj).some(v => typeof v === "string" && v.trim() !== "")
    );
  }

  get tindakanOptions() {
    if (this.isMaternalKategori) {
      return [
        { id: "t1", name: "Partus Pervaginam" },
        { id: "t2", name: "Vaccum Ekstrasi" },
        { id: "t3", name: "Sectio Caesaria" },
        { id: "t4", name: "Kuretase" },
        { id: "t5", name: "Kuretase PUA" }
      ];
    }

    return [{ id: "t6", name: "Umum" }];
  }

  get listUser() {
    return storePerawat.listKaryawan;
  }

  get durasi() {
    if (this.opStartedAt && this.opEndedAt) {
      const hdiff = moment(this.opEndedAt).diff(
          moment(this.opStartedAt),
          "hours"
        ),
        mdiff = moment(this.opEndedAt).diff(
          moment(this.opStartedAt),
          "minutes"
        );

      const hStr = hdiff ? `${hdiff} jam` : "";
      const mStr = mdiff % 60 ? `${mdiff % 60} menit` : "";

      if (hdiff < 0 || mdiff < 0) {
        if (this.viewOnly) return "";
        this.opTimeEndedAt = null;
        alert(
          "Durasi tindakan tidak bisa minus. Silahkan perbaiki lagi Waktu Mulai atau Waktu Selesai tindakan!"
        );

        this.$nextTick(() => {
          this.refOpTimeEndedAt.focus();
        });

        return "";
      } else {
        return `${hStr} ${mStr}`.trim();
      }
    } else {
      return "";
    }
  }

  get requestParams() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.stateUser.unit_id,
      dr_op1_id: this.drOp1,
      dr_op2_id: this.drOp2,
      dr_anestesi_id: this.drAnestesi,
      asisten_id: this.asisten,
      perawat_id: this.perawat,
      asisten_anestesi_id: this.asistenAnestesi,
      category: this.namaTindakan,
      category_text: this.namaTindakanText,
      jenis_tindakan: this.jenisTindakan,
      klasifikasi_tindakan: this.klasifikasiTindakan,
      implant: this.implant,
      jenis_implant: this.jenisImplant,
      jenis_anestesi: this.jenisAnestesi,
      jaringan_eksisi: this.jaringanEksisi,
      perdarahan_ml: this.perdarahanMl === null || this.perdarahanMl === ("" as any) ? null : this.perdarahanMl,
      transfusi_ml: this.transfusiMl === null || this.transfusiMl === ("" as any) ? null : this.transfusiMl,
      transfusi_komponen: this.transfusiKomponen || null,
      komplikasi: this.komplikasi,
      komplikasi_text: this.komplikasiText,
      pemeriksaan_pa: this.pemeriksaanPa,
      op_started_at: this.opStartedAt
        ? moment(this.opStartedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      op_ended_at: this.opEndedAt
        ? moment(this.opEndedAt).format("YYYY-MM-DD HH:mm:ss")
        : null,
      diag_pra: this.dxPraOps,
      diag_pasca: this.dxPascaOps,
      pengobatan: this.pengobatan,
      lap_ops_op1: this.lapOpsModeBebas ? this.lapOps : null,
      lap_ops_op2: this.lapOpsOp2,
      lap_ops_struct: this.lapOpsModeBebas ? null : this.lapOpsStruct,
      instruksi_op1: this.instruksiModeBebas ? this.instruksiOp1 : null,
      instruksi_op2: this.instruksiOp2,
      instruksi_struct: this.instruksiModeBebas ? null : this.instruksiStruct
      // pelaksana: this.pelaksana
    };
  }

  get fOpenDr1() {
    const drOp1 = this.data?.dr_op1_id || false,
      signedDrOp1 = this.data?.dr_op1_signed_at || false;

    return drOp1 && !signedDrOp1;
  }

  get fOpenDr2() {
    const drOp2 = this.data?.dr_op2_id || false,
      signedDrOp2 = this.data?.dr_op2_signed_at || false;

    return drOp2 && !signedDrOp2;
  }

  get isEditable() {
    // if (this.data) {
    if (!this.id) {
      return true;
    }
    console.log(
      "forceEdit",
      this.forceEdit,
      "op1",
      this.fOpenDr1,
      "op2",
      this.fOpenDr2
    );
    return this.forceEdit || this.fOpenDr1 || this.fOpenDr2;
  }

  get canForceEdit() {
    const isSignedByOp1 = !!this.data?.dr_op1_signed_at;
    const isCurrentUserOp1 = this.data?.dr_op1_id == this.stateUser.id;

    return this.id && isSignedByOp1 && isCurrentUserOp1 && !this.forceEdit;
  }

  get loading() {
    return LaporanOperasiStore.loading;
  }

  get canDelete() {
    return this.data && this.data?.dr_op1_id == this.stateUser.id;
  }

  setForceEdit() {
    const q = confirm(
      "Edit dokumen yang sudah ditandatangani dapat menghapuskan semua tanda tangan, sehingga dokumen harus ditandatangani ulang. Dilanjutkan?"
    );

    if (q) {
      this.forceEdit = true;
    }
  }

  save() {
    if (this.viewOnly) return;
    if (!this.saving) {
      this.saving = true;
      this.showData = false;

      const save = this.id
        ? LaporanOperasi.update(this.id, this.requestParams)
        : LaporanOperasi.create(this.requestParams);

      let drOpSign = null;
      if (this.stateUser.id == this.drOp1 && !this.drOp1SignedAt) {
        drOpSign = "op1";
      } else if (this.stateUser.id == this.drOp2 && !this.drOp2SignedAt) {
        drOpSign = "op2";
      }

      save
        .then(resp => {
          if (resp.status === 1) {
            appModule.NoticeDelay("Berhasil membuat Laporan Operasi");

            this.$emit("reload", resp.data);

            if (drOpSign) {
              this.$nextTick(() => {
                this.showSignModal(drOpSign);
              });
            }
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  remove() {
    if (this.viewOnly) return;
    const conf = confirmRemove("Laporan Operasi");

    if (conf) {
      LaporanOperasi.destroy(this.id).then(resp => {
        if (resp.status == 1) {
          appModule.NoticeDelay("Berhasil menghapus Laporan Operasi");

          // this.getByRegister();
          this.$emit("reload");
        }
      });
    }
  }

  toRadioInt(val: unknown): number | null {
    if (val === null || val === undefined || val === "") return null;
    const n = parseInt(String(val), 10);
    return Number.isNaN(n) ? null : n;
  }

  async fillInputFields(dt) {
    // this.clear();

    if (dt) {
      this.hydrating = true;
      this.id = dt.id;
      // tab mengikuti kategori record yang dibuka
      this.kategoriTab = ["t1", "t2", "t3", "t4", "t5"].includes(dt.category)
        ? 1
        : 0;
      // record lama tanpa/berbeda kategori pada tab Umum tetap dipaksa ke "t6"
      this.namaTindakan = this.tindakanOptions.some(o => o.id === dt.category)
        ? dt.category
        : this.defaultCategory;
      this.namaTindakanText = dt.category_text;
      this.klasifikasiTindakan = dt.klasifikasi_tindakan;
      this.jenisTindakan = dt.jenis_tindakan;
      this.drOp1 = dt.dr_op1_id;
      this.drOp2 = dt.dr_op2_id;
      this.drAnestesi = dt.dr_anestesi_id;
      this.asisten = dt.asisten_id;
      this.implant = dt.implant;
      this.jenisImplant = dt.jenis_implant;
      this.jenisAnestesi = dt.jenis_anestesi;
      this.jaringanEksisi = dt.jaringan_eksisi;
      this.perdarahanMl =
        dt.perdarahan_ml === null || dt.perdarahan_ml === undefined
          ? null
          : Number(dt.perdarahan_ml);
      this.transfusiMl =
        dt.transfusi_ml === null || dt.transfusi_ml === undefined
          ? null
          : Number(dt.transfusi_ml);
      this.transfusiKomponen = dt.transfusi_komponen || null;
      this.komplikasi = this.toRadioInt(dt.komplikasi);
      this.komplikasiText = dt.komplikasi_text;
      this.pemeriksaanPa = this.toRadioInt(dt.pemeriksaan_pa);
      const tglOp = moment(dt.op_started_at).format("YYYY-MM-DD HH:mm:ss"),
        tglOpSl = moment(dt.op_ended_at).format("YYYY-MM-DD HH:mm:ss");

      // this.tglOperasi = moment(dt.op_started_at).format("YYYY-MM-DD");
      // this.tglSelesaiOperasi = moment(dt.op_ended_at).format("YYYY-MM-DD");
      this.tglOperasi = tglOp.substr(0, 10);
      this.tglSelesaiOperasi = tglOpSl.substr(0, 10);
      // this.$nextTick(() => {
      this.opTimeStartedAt = tglOp.substr(11, 5);
      this.opTimeEndedAt = tglOpSl.substr(11, 5);
      // });
      this.dxPraOps = dt.diag_pra;
      this.dxPascaOps = dt.diag_pasca;
      this.pengobatan = dt.pengobatan;
      this.lapOpsOp2 = dt.lap_ops_op2;
      this.instruksiOp2 = dt.instruksi_op2;
      this.asisten = dt.asisten_id;
      this.perawat = dt.perawat_id;
      this.asistenAnestesi = dt.asisten_anestesi_id;
      this.drOp1SignedAt = dt.dr_op1_signed_at
        ? DateFormat.formatISODate(dt.dr_op1_signed_at)
        : null;
      this.drOp2SignedAt = dt.dr_op2_signed_at
        ? DateFormat.formatISODate(dt.dr_op2_signed_at)
        : null;
      this.drOp1Identity = dt.dokter_operator1;
      this.drOp2Identity = dt.dokter_operator2;

      this.lapOps = dt.lap_ops_op1;
      this.instruksiOp1 = dt.instruksi_op1;

      const lapStruct = (dt as any).lap_ops_struct;
      if (lapStruct && typeof lapStruct === "object") {
        for (const k of Object.keys(this.lapOpsStruct)) {
          this.lapOpsStruct[k] = lapStruct[k] ?? null;
        }
      }
      this.lapOpsModeBebas = this.objectHasValue(lapStruct)
        ? false
        : dt.lap_ops_op1
        ? true
        : this.defaultModeBebas;

      const instStruct = (dt as any).instruksi_struct;
      if (instStruct && typeof instStruct === "object") {
        for (const k of Object.keys(this.instruksiStruct)) {
          this.instruksiStruct[k] = instStruct[k] ?? null;
        }
      }
      this.instruksiModeBebas = this.objectHasValue(instStruct)
        ? false
        : dt.instruksi_op1
        ? true
        : this.defaultModeBebas;

      this.$nextTick(() => {
        this.hydrating = false;
      });
    }

    this.forceEdit = false;
  }

  previewForm() {
    LaporanOperasi.print(this.id);
  }

  clear() {
    this.id = null;
    this.drOp1 = null;
    this.drOp2 = null;
    this.drAnestesi = null;
    this.implant = null;
    this.jenisImplant = null;
    this.jaringanEksisi = null;
    this.komplikasi = null;
    this.komplikasiText = null;
    this.jenisAnestesi = null;
    this.pemeriksaanPa = null;
    // this.opStartedAt = null;
    // this.opEndedAt = null;
    this.tglOperasi = moment().format("YYYY-MM-DD");
    this.tglSelesaiOperasi = moment().format("YYYY-MM-DD");
    this.opTimeStartedAt = null;
    this.opTimeEndedAt = null;
    this.dxPraOps = null;
    this.dxPascaOps = null;
    this.namaTindakan = this.defaultCategory;
    this.jenisTindakan = null;
    this.klasifikasiTindakan = null;
    this.lapOps = null;
    this.instruksiOp1 = null;
    this.lapOpsOp2 = null;
    this.instruksiOp2 = null;
    this.drOp1SignedAt = null;
    this.drOp2SignedAt = null;
    this.signeeRole = null;
    this.forceEdit = false;
    this.asisten = [];
    this.perawat = [];
    this.asistenAnestesi = [];
    this.pengobatan = null;
    this.namaTindakanText = null;
    this.perdarahanMl = null;
    this.transfusiMl = null;
    this.transfusiKomponen = null;
    for (const k of Object.keys(this.lapOpsStruct)) {
      this.lapOpsStruct[k] = null;
    }
    for (const k of Object.keys(this.instruksiStruct)) {
      this.instruksiStruct[k] = null;
    }
    this.lapOpsModeBebas = this.defaultModeBebas;
    this.instruksiModeBebas = this.defaultModeBebas;
  }

  // @Watch("opStartedAt")
  // changedStartedAt(val) {
  //   if (val) {
  //     if (this.opEndedAt && val > this.opEndedAt) {
  //       alert(
  //         "Tanggal dan Jam mulai tindakan tidak boleh lebih besar dari Tgl dan Jam selesai tindakan!"
  //       );
  //       // this.opStartedAt = null;
  //       this.tglOperasi = null;
  //       this.opTimeStartedAt = null;
  //     }
  //   } else {
  //     // this.opStartedAtPicker["clearHandler"]();
  //     this.refOpTimeStartedAt["clearHandler"]();
  //   }
  // }

  // @Watch("opEndedAt")
  // changedEndedAt(val) {
  //   if (val) {
  //     if (this.opStartedAt && val < this.opStartedAt) {
  //       setTimeout(() => {
  //         this.tglSelesaiOperasi = null;
  //         this.opTimeEndedAt = null;

  //         this.refTglSelesaiOperasi.focus();
  //       }, 500);

  //       alert(
  //         "Tanggal dan Jam selesai tindakan tidak boleh lebih kecil dari Tgl dan Jam mulai tindakan!"
  //       );
  //     }
  //   } else {
  //     // this.opEndedAtPicker["clearHandler"]();
  //     this.refOpTimeEndedAt["clearHandler"]();
  //   }
  // }

  @Watch("kategori", { immediate: true })
  changeKategori() {
    if (this.id) return;

    if (!this.tindakanOptions.some(o => o.id === this.namaTindakan)) {
      this.namaTindakan = this.defaultCategory;
    }

    if (!this.lapOps && !this.lapOpsStructHasValue) {
      this.lapOpsModeBebas = this.defaultModeBebas;
    }
    if (!this.instruksiOp1 && !this.instruksiStructHasValue) {
      this.instruksiModeBebas = this.defaultModeBebas;
    }
  }

  @Watch("implant")
  changeRefJenisImplant(val) {
    if (this.hydrating || this.viewOnly) return;
    if (val) {
      this.$nextTick(() => {
        this.refJenisImplant.focus();
      });
    }
  }

  @Watch("data", { immediate: true, deep: true })
  changeData(val) {
    if (val && Object.keys(val).length > 0) {
      // Cek jika val adalah objek non-kosong
      this.fillInputFields(val);
    } else {
      this.clear();
      // Record baru (addNew parent sudah digating readOnly): soft-prefill
      // dx pre-op/EBL/transfusi dari rantai perioperatif register ini.
      if (this.register) {
        this.$nextTick(() => {
          this.loadPrefill({
            pasien_rm: String(this.rm),
            register_id: this.register
          });
        });
      }
    }
  }

  get showOnUmum() {
    return this.namaTindakan == "t6";
  }

  get showOnPersalinan() {
    return ["t1", "t2"].includes(this.namaTindakan);
  }

  get showOnKuretase() {
    return ["t3", "t4", "t5"].includes(this.namaTindakan);
  }

  @Watch("namaTindakan")
  changeJenisTindakan(val) {
    if (this.hydrating) return;

    // hanya isi auto-template terstruktur kalau record belum berisi narasi
    // (mencegah meng-override data lama yang masih free-text)
    const adaNarasiLama = !!(this.lapOps || this.instruksiOp1);
    if (
      !this.id &&
      ["t1", "t2", "t3", "t4", "t5"].includes(val) &&
      !adaNarasiLama
    ) {
      this.lapOpsModeBebas = false;
      this.instruksiModeBebas = false;

      if (["t1", "t2"].includes(val)) {
        this.setTemplatePersalinan();
      }

      if (val === "t3") {
        this.setTemplateSC();
      }

      if (["t4", "t5"].includes(val)) {
        this.setTemplateKuretase();
      }
    }

    if (!this.showOnUmum) {
      this.implant = null;
      this.namaTindakanText = null;
    }

    if (!this.showOnKuretase) {
      this.jenisAnestesi = null;
    }

    if (!this.showOnUmum && !this.showOnPersalinan) {
      this.komplikasi = null;
    }

    if (!this.showOnUmum && !this.showOnKuretase) {
      this.pemeriksaanPa = null;
      this.lapOpsOp2 = null;
      this.instruksiOp2 = null;
      this.drOp2 = null;
      this.drAnestesi = null;
      this.asistenAnestesi = [];
    }
  }

  @Watch("signModalShow")
  changeSignModalShow(val) {
    if (!val) {
      this.signeeRole = null;
    }
  }

  @Watch("implant")
  changeImplant(val) {
    if (this.hydrating || this.viewOnly) return;
    if (!val) {
      this.jenisImplant = null;
    }
  }

  @Watch("drOp1")
  changeDrOp1(val) {
    if (val && val == this.drOp2) {
      alert("DPJP dan Dokter Operator ke-2 tidak boleh sama!");
      this.drOp1 = null;
    }
  }

  @Watch("drOp2")
  changeDrOp2(val) {
    if (val && val == this.drOp1) {
      alert("DPJP dan Dokter Operator ke-2 tidak boleh sama!");
      this.drOp2 = null;
    }
  }

  @Watch("lapOpsOp2")
  changeLapOpsOp2(val) {
    if (!val) {
      this.drOp2 = null;
    }
  }

  @Watch("tglOperasi")
  changeTglOperasi(val: string) {
    if (this.hydrating || this.viewOnly) return;
    if (val && val.length >= 10) {
      this.$nextTick(() => {
        this.refOpTimeStartedAt.focus();
      });
    }
  }

  @Watch("opTimeStartedAt")
  changeOpTimeStartedAt(val: string) {
    if (this.hydrating || this.viewOnly) return;
    if (val && val.length >= 5) {
      if (val > "22:00") {
        this.tglSelesaiOperasi = moment()
          .add(1, "days")
          .format("YYYY-MM-DD");
      } else {
        this.tglSelesaiOperasi = this.tglOperasi;
      }

      this.$nextTick(() => {
        this.refTglSelesaiOperasi.focus();
      });
    }
  }

  @Watch("tglSelesaiOperasi")
  changeTglSelesaiOperasi(val: string) {
    if (this.hydrating || this.viewOnly) return;
    if (val && val.length >= 10) {
      this.$nextTick(() => {
        this.refOpTimeEndedAt.focus();
      });
    }
  }

  @Watch("opTimeEndedAt")
  changeOpTimeEndedAt(val: string) {
    if (this.hydrating || this.viewOnly) return;
    if (val && val.length >= 5) {
      this.$nextTick(() => {
        this.refDxPraOps.focus();
      });
    }
  }

  signModalShow = false;
  signeeRole = null;

  showSignModal(role) {
    if (this.viewOnly) return;
    this.signeeRole = role;
    this.signModalShow = true;
  }

  postSignature(val) {
    if (this.viewOnly) return;
    appModule.setLoading(true);

    LaporanOperasi.sign(this.id, { password: val, role: this.signeeRole })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          // this.getByRegister();
          this.$emit("reload");
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.signModalShow = false;
      });
  }

  fillLapOpsStructIfEmpty(values: Record<string, string>) {
    for (const k of Object.keys(values)) {
      const cur = this.lapOpsStruct[k];
      if (!cur || (typeof cur === "string" && cur.trim() === "")) {
        this.lapOpsStruct[k] = values[k];
      }
    }
  }

  fillInstruksiStructIfEmpty(values: Record<string, string>) {
    for (const k of Object.keys(values)) {
      const cur = this.instruksiStruct[k];
      if (!cur || (typeof cur === "string" && cur.trim() === "")) {
        this.instruksiStruct[k] = values[k];
      }
    }
  }

  setTemplatePersalinan() {
    this.fillLapOpsStructIfEmpty({
      posisi_pasien: "Litotomi",
      persiapan_antisepsis: "Desinfeksi vulva-perineum, drape steril",
      insisi: "Episiotomi (mediolateral / median) bila indikasi",
      prosedur: `Pukul ............ : Pasien merasa ingin mengejan
Diagnosis : Kala II G..P..A.. hamil ............ minggu
Tatalaksana : Pimpin persalinan / Vakum Ekstraksi / Episiotomi
Pukul ............ : Bayi 1 lahir, JK (L/P), BB ........ gr, PB ........ cm, AS ...../.....
Pukul ............ : Bayi 2 lahir, JK (L/P), BB ........ gr, PB ........ cm, AS ...../.....
Pukul ............ : Plasenta lahir (Lengkap / Tidak lengkap)
Diagnosis : Kala III P..A..
Tatalaksana : MAK III (oksitosin 10 IU IM, PTT, masase uterus); pengawasan 2 jam pasca salin`,
      spesimen: "Plasenta + selaput ketuban (kirim PA bila indikasi)",
      penutupan:
        "Jahit luka episiotomi/laserasi (catgut chromic 2-0) lapis demi lapis bila ada",
      komplikasi_intraop: "Tidak ada"
    });

    this.fillInstruksiStructIfEmpty({
      mobilisasi: "Mobilisasi dini (2-4 jam pasca salin)",
      diet: "Diet biasa setelah kondisi stabil",
      medikamentosa:
        "Amoxicillin 3x500 mg PO, Asam mefenamat 3x500 mg PO, SF 1x1 tab PO",
      monitoring:
        "TTV + kontraksi uterus + perdarahan/15 mnt 2 jam pertama, lalu/jam",
      perawatan_luka: "Vulva hygiene; ganti pembalut bila penuh",
      rencana_kontrol: "Kontrol poli obgyn 7 hari pasca salin"
    });
  }

  setTemplateSC() {
    this.fillLapOpsStructIfEmpty({
      posisi_pasien: "Supine, tilt kiri 15°",
      persiapan_antisepsis:
        "Desinfeksi povidone iodine 10% area abdomen, drape steril",
      insisi:
        "Pfannenstiel / Joel Cohen / Linea Mediana / Misgav Ladach, panjang ~12 cm",
      temuan_intraop:
        "Air ketuban: jernih / mekoneum / hijau; volume normal / oligohidramnion / polihidramnion",
      prosedur: `Pukul ............ : Operasi dimulai
- Bladder flap dibuat pada plica vesicouterina
- Insisi uterus pada segmen bawah rahim (SBR) transversal
- Selaput ketuban dipecah
Pukul ............ : Bayi 1 lahir, JK (L/P), BB ........ gr, PB ........ cm, AS ...../.....
Pukul ............ : Bayi 2 lahir, JK (L/P), BB ........ gr, PB ........ cm, AS ...../.....
Pukul ............ : Plasenta lahir lengkap / tidak lengkap; insersi IUD: ya / tidak`,
      spesimen: "Plasenta (kirim PA bila indikasi)",
      penutupan: `Segmen rahim: jelujur terkunci / satu-satu, satu lapis / dua lapis
Reperitonealisasi: ya / tidak
Cuci kavum: NaCl 0,9% / tidak
Fascia: jelujur (vicryl 1-0); subkutan: satu-satu (plain catgut 3-0); kulit: subkutikuler / satu-satu`,
      komplikasi_intraop: "Tidak ada"
    });

    this.fillInstruksiStructIfEmpty({
      mobilisasi: "Bed rest 6-8 jam, lalu mobilisasi bertahap",
      diet: "Puasa s/d bising usus +, lalu diet bertahap (cair → lunak)",
      medikamentosa:
        "Cefazolin 1 g IV (profilaksis), Ketorolac 30 mg IV/8 jam, oksitosin drip sesuai indikasi",
      monitoring:
        "TTV + kontraksi + perdarahan + urin/jam 6 jam pertama, balans cairan 24 jam",
      penunjang: "DR ulang H+1",
      perawatan_luka: "GV H+2, AFF drain bila produksi < 50 cc/24 jam",
      rencana_kontrol: "Rencana pulang H+3, kontrol poli obgyn 7 hari"
    });
  }

  setTemplateKuretase() {
    this.fillLapOpsStructIfEmpty({
      posisi_pasien: "Litotomi",
      persiapan_antisepsis: "Desinfeksi vulva-vagina, drape steril",
      insisi: "Tidak ada (tindakan transvaginal)",
      prosedur: `Pukul ............ : Prosedur kuretase dimulai
- Spekulum dipasang, portio ditampilkan & dicekam dengan tenakulum
- Sondase arah antefleksi / retrofleksi; panjang rongga uterus ........ cm
- Kuretase dilakukan dengan sendok / suction kuretase nomor : 1/2/3/4/5
- Pemberian uterotonika: Methilergometrin / Oksitosin / Prostaglandin / tidak diberikan
Pukul ............ : Tindakan selesai`,
      spesimen: "Jaringan hasil kuretase: ........ ml (kirim PA)",
      penutupan: "Tidak ada (tindakan transvaginal)",
      komplikasi_intraop: "Tidak ada"
    });

    this.fillInstruksiStructIfEmpty({
      mobilisasi: "Boleh mobilisasi setelah efek anestesi hilang",
      diet: "Diet biasa setelah kondisi stabil",
      medikamentosa:
        "Amoxicillin 3x500 mg PO, Asam mefenamat 3x500 mg PO, uterotonika sesuai indikasi",
      monitoring: "TTV + perdarahan pervaginam 2 jam pasca tindakan",
      perawatan_luka: "Vulva hygiene; ganti pembalut bila penuh",
      rencana_kontrol: "Kontrol poli obgyn 7 hari; tunggu hasil PA"
    });
  }

  close() {
    this.$emit("close");
    this.clear();
  }
}
